import {
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { DataService } from './services/data.service';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { provideAuth0 } from '@auth0/auth0-angular';
import { addJwtTokenInterceptor } from './http-interceptors/add-jwt-token-interceptor';
import {
  AllEnterpriseModule,
  LicenseManager,
  ModuleRegistry,
} from 'ag-grid-enterprise';

ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-092855}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cascade_Designs_Inc.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{reports.cascadedesigns.com}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{reports.cascadedesigns.com}_need_to_be_licensed___{reports.cascadedesigns.com}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{12_August_2026}____[v3]_[01]_MTc4NjQ4OTIwMDAwMA==a4acaca608e12cb9824f89c812812635'
);

export const appConfig: ApplicationConfig = {
  providers: [
    DataService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    provideAuth0({
      domain: environment.authDomain,
      clientId: environment.authClientId,
      authorizationParams: {
        audience: environment.authAudience,
        scope: environment.authScope,
        redirect_uri: environment.redirect_uri,
      },
    }),

    provideRouter(routes),
    provideHttpClient(withInterceptors([addJwtTokenInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: 'false',
        },
      },
    }),
  ],
};
